// extracted by mini-css-extract-plugin
module.exports = {"rippleRoot":"ripple_rippleRoot__2meXk","ripple":"ripple_ripple__1Bbw3","rippleStart":"ripple_rippleStart__23TR1","rippleEnd":"ripple_rippleEnd__eGUwE"};